import * as React from 'react'
import Navbar from '../../setup/Navbar'
import { 
    Container, Grid2, Typography, Box, Dialog, DialogTitle, DialogContent, 
    DialogActions, Tab, Tabs, Button, Paper, Alert, Chip, FormControlLabel, Switch
} from '@mui/material'
import dayjs from 'dayjs'
import DatePickerSelf from '../../../BuiltInComponent/DatePricker'
import TextFields from '../../../BuiltInComponent/TextField'
import Loading from '../../../BuiltInComponent/Loading'
import AutoComplete from '../../../BuiltInComponent/AutoComplete'
import ButtonNormal from '../../../BuiltInComponent/ButtonNormal'
import StickyHeadTable from '../../../BuiltInComponent/TableWithPagination'
import { useDispatch, useSelector } from 'react-redux'
import { getDepartments, getItemList } from '../../../features/setup/useableSlice'
import { 
    getAuditData, 
    addMasterRecord, 
    addItem, 
    updateAuditItem,
    deleteAuditItem,
    getVarianceReport,
    approveAudit,
    rejectAudit,
    getAuditHistory,
    getSystemStock,
    applyAuditToStock
} from '../../../features/AdminManagement/auditSlice'
import { useLocation, useNavigate } from 'react-router-dom'
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace'
import HeadingText from '../../../BuiltInComponent/HeadingTest'
import StatusText from '../../../BuiltInComponent/StatusText'
import BasicAlerts from '../../../BuiltInComponent/Alert'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'
import DownloadIcon from '@mui/icons-material/Download'
import CloudUploadIcon from '@mui/icons-material/CloudUpload'
import HistoryIcon from '@mui/icons-material/History'
import AssignmentIcon from '@mui/icons-material/Assignment'

export default function Audit() {

    const dispatch = useDispatch()
    const navigate = useNavigate()
    const location = useLocation()
    const { isLoading, items, departments } = useSelector((state) => state.ru)
    const { masterData, auditHistory, varianceReport, systemStock } = useSelector((state) => state.audit)
    const [currentUser] = React.useState(
        JSON.parse(localStorage.getItem('user')) || JSON.parse(localStorage.getItem('userData')) || {}
    )

    const [tabValue, setTabValue] = React.useState(0)
    const [editingRONO, setEditingRONO] = React.useState(null)
    const [showEditDialog, setShowEditDialog] = React.useState(false)
    const [showVarianceReport, setShowVarianceReport] = React.useState(false)
    const [showAuditHistory, setShowAuditHistory] = React.useState(false)
    const [showApprovalDialog, setShowApprovalDialog] = React.useState(false)
    const [approvalType, setApprovalType] = React.useState('approve')
    const [approvalComment, setApprovalComment] = React.useState('')
    const [RONO, setRONO] = React.useState(0)
    const [showAlert, setShowAlert] = React.useState(false)

    React.useEffect(() => {
        dispatch(getDepartments())
        dispatch(getItemList())
    }, [dispatch])

    const [auditMData, setAuditMData] = React.useState({
        entDate: dayjs(new Date()).format('MM-DD-YYYY'),
        auditID: location.state?.auditID || '',
        departmentID: '',
        auditBranch: currentUser?.branchID || '',
        remarks: '',
        openingStockValue: 0,
        auditStatus: true,
        userID: currentUser?.userID || ''
    })

    const [auditDData, setAuditDData] = React.useState({
        itemCode: '',
        quantity: 0,
        openingStock: 0,
        currentSystemStock: 0,
        createdBy: currentUser?.userID || ''
    })

    React.useEffect(() => {
        if (location.state?.auditID) {
            dispatch(getAuditData({ auditID: location.state?.auditID }))
                .then(res => {
                    if (res.payload && res.payload.status) {
                        const data = res.payload.data
                        if (data.length > 0) {
                            setAuditMData(prev => ({
                                ...prev,
                                auditID: data[0].auditID,
                                entDate: data[0].entDate,
                                departmentID: data[0].departmentID,
                                remarks: data[0].remarks,
                                auditStatus: data[0].auditStatus,
                                approvalStatus: data[0].approvalStatus,
                                openingStockValue: data[0].openingStockValue,
                                userID: data[0].userID,
                                appliedToStock: data[0].appliedToStock
                            }))
                        }
                    }
                })
            dispatch(getAuditHistory({ auditID: location.state?.auditID }))
            dispatch(getVarianceReport({ auditID: location.state?.auditID }))
        }
    }, [dispatch, location.state?.auditID])

    const tableColumns = [
        { fieldName: 'RONO', cName: 'Item Code', textAlign: 'left', width: 80, status: 'en', dType: 'string' },
        { fieldName: 'itemDesc', cName: 'Description', textAlign: 'left', width: 200, status: 'en', dType: 'string' },
        { fieldName: 'openingStock', cName: 'Opening Qty', textAlign: 'right', width: 80, status: 'en', dType: 'number' },
        { fieldName: 'currentSystemStock', cName: 'System Qty', textAlign: 'right', width: 80, status: 'en', dType: 'number' },
        { fieldName: 'quantity', cName: 'Audited Qty', textAlign: 'right', width: 80, status: 'en', dType: 'number' },
        { fieldName: 'variance', cName: 'Variance', textAlign: 'right', width: 80, status: 'en', dType: 'number' },
        { fieldName: 'systemRate', cName: 'Rate', textAlign: 'right', width: 80, status: 'en', dType: 'number' },
        { fieldName: 'priceVariance', cName: 'Price Variance', textAlign: 'right', width: 100, status: 'en', dType: 'number' },
        { fieldName: 'Edit', cName: 'Edit', textAlign: 'center', width: 50, status: 'en', dType: 'string' },
        { fieldName: 'Delete', cName: 'Delete', textAlign: 'center', width: 50, status: 'en', dType: 'string' },
        { fieldName: 'Button', cName: '', textAlign: 'center', width: 50, status: 'dis', dType: 'string' },
    ]

    const onChange = (data) => {
        if (!data) return
        const keys = Object.keys(data)
        if (keys[0] === 'departmentID') {
            setAuditMData(prevState => ({
                ...prevState,
                departmentID: data[keys]
            }))
        }
        else if (keys[0] === 'itemCode') {
            const selectedItem = items.find(i => i.itemCode === data[keys])
            // Set itemCode immediately so dropdown doesn't reset
            setAuditDData(prevState => ({ ...prevState, itemCode: data[keys], currentSystemStock: 0, openingStock: 0 }))
            if (selectedItem) {
                dispatch(getSystemStock({ itemCode: selectedItem.itemCode, branchID: auditMData.auditBranch }))
                    .then(res => {
                        if (res.payload && res.payload.data && res.payload.data.length > 0) {
                            const currentStock = Number(res.payload.data[0].currentStock) || 0
                            setAuditDData(prevState => ({
                                ...prevState,
                                currentSystemStock: currentStock,
                                openingStock: currentStock
                            }))
                        }
                    })
            }
        }
        else {
            setAuditMData(prevData => ({
                ...prevData, 
                [keys]: data[keys]
            }))
            setAuditDData(prevData => ({
                ...prevData, 
                [keys]: data[keys]
            }))
        }
    }

    const onMasterSave = async () => {
        if (auditMData.auditID === '') {
            dispatch(addMasterRecord({
                ...auditMData,
                userID: currentUser?.userID
            })).then((res) => {
                console.log('Audit Master Added', res.payload)
                if (res.payload && res.payload.data && res.payload.data.length > 0) {
                    setAuditMData({
                        ...auditMData,
                        auditID: res.payload.data[0].auditID,
                    })
                }
            })
        } else {
            dispatch(addMasterRecord({
                ...auditMData,
                userID: currentUser?.userID
            }))
        }
    }

    const onDetailSave = async () => {
        if (!auditDData.itemCode) {
            alert('Please select an item')
            return
        }
        if (!auditDData.quantity) {
            alert('Please enter quantity')
            return
        }

        dispatch(addItem({
            ...auditDData,
            auditID: auditMData.auditID,
            createdBy: currentUser?.userID
        }))
        
        setAuditDData({
            itemCode: '',
            quantity: 0,
            openingStock: 0,
            currentSystemStock: 0,
            createdBy: currentUser?.userID
        })
    }

    const onEditClick = async (RONO) => {
        const itemToEdit = masterData?.data?.find(item => item.RONO === RONO)
        if (itemToEdit) {
            setEditingRONO(RONO)
            setAuditDData({
                itemCode: itemToEdit.itemCode,
                quantity: itemToEdit.quantity,
                openingStock: itemToEdit.openingStock,
                currentSystemStock: itemToEdit.currentSystemStock,
                createdBy: currentUser?.userID
            })
            setShowEditDialog(true)
        }
    }

    const onEditSave = async () => {
        dispatch(updateAuditItem({
            RONO: editingRONO,
            ...auditDData,
            createdBy: currentUser?.userID
        }))
        setShowEditDialog(false)
        setEditingRONO(null)
    }

    const onDeleteClick = async (RONO) => {
        if (window.confirm('Are you sure you want to delete this item?')) {
            dispatch(deleteAuditItem({
                RONO: RONO,
                createdBy: currentUser?.userID
            }))
        }
    }

    const refreshAuditAfterDecision = async () => {
        await dispatch(getAuditData({ auditID: auditMData.auditID }))
        await dispatch(getAuditHistory({ auditID: auditMData.auditID }))
        await dispatch(getVarianceReport({ auditID: auditMData.auditID }))
    }

    const handleApprove = async () => {
        const res = await dispatch(approveAudit({
            auditID: auditMData.auditID,
            approverID: currentUser?.userID,
            approvalComments: approvalComment
        }))

        if (res.payload && !res.error) {
            await refreshAuditAfterDecision()
            setAuditMData(prev => ({ ...prev, approvalStatus: 'Approved' }))
            setShowApprovalDialog(false)
            setApprovalComment('')
        } else {
            alert('Approve failed. Please try again.')
        }
    }

    const handleReject = async () => {
        const res = await dispatch(rejectAudit({
            auditID: auditMData.auditID,
            approverID: currentUser?.userID,
            rejectionReason: approvalComment
        }))

        if (res.payload && !res.error) {
            await refreshAuditAfterDecision()
            setAuditMData(prev => ({ ...prev, approvalStatus: 'Rejected' }))
            setShowApprovalDialog(false)
            setApprovalComment('')
        } else {
            alert('Reject failed. Please try again.')
        }
    }

    const exportToCSV = () => {
        if (!masterData?.data || masterData.data.length === 0) {
            alert('No data to export')
            return
        }

        const headers = ['Item Code', 'Description', 'Opening Stock', 'System Stock', 'Audited Quantity', 'Variance', 'Rate', 'Price Variance']
        const rows = masterData.data.map(item => [
            item.itemCode,
            item.itemDesc,
            item.openingStock,
            item.currentSystemStock,
            item.quantity,
            item.variance,
            item.systemRate,
            item.priceVariance
        ])

        let csvContent = 'data:text/csv;charset=utf-8,'
        csvContent += headers.join(',') + '\n'
        rows.forEach(row => {
            csvContent += row.join(',') + '\n'
        })

        const encodedUri = encodeURI(csvContent)
        const link = document.createElement('a')
        link.setAttribute('href', encodedUri)
        link.setAttribute('download', `audit_${auditMData.auditID}_${dayjs().format('YYYY-MM-DD')}.csv`)
        document.body.appendChild(link)
        link.click()
    }

    const getApprovalStatusColor = (status) => {
        switch (status) {
            case 'Approved':
                return 'success'
            case 'Rejected':
                return 'error'
            case 'Pending':
                return 'warning'
            default:
                return 'default'
        }
    }

    return (
        <>
            <Navbar />
            <Container>
                {showAlert && (
                    <BasicAlerts
                        msg="Some fields are required."
                        getCloseCommand={setShowAlert}
                    />
                )}

                <Grid2 container spacing={2} sx={{ marginTop: '20px' }}>
                    <Grid2 size={12}>
                        <KeyboardBackspaceIcon
                            sx={{
                                fontSize: 30, marginLeft: -1, color: 'white', cursor: 'pointer',
                                backgroundColor: '#1D4988', padding: 1, borderRadius: 50
                            }}
                            onClick={() => { navigate('/AuditListing') }} />
                    </Grid2>

                    <Grid2 size={12} sx={{ marginTop: 3 }}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <HeadingText text={'Inventory Audit Form'} />
                            {auditMData.auditID && (
                                <Chip 
                                    label={auditMData.approvalStatus || 'Draft'} 
                                    color={getApprovalStatusColor(auditMData.approvalStatus)}
                                    variant="outlined"
                                />
                            )}
                        </Box>
                    </Grid2>

                    <Grid2 size={12}>
                        <Tabs value={tabValue} onChange={(e, newValue) => setTabValue(newValue)}>
                            <Tab label="Master Data" />
                            <Tab label="Audit Items" disabled={!auditMData.auditID} />
                            <Tab label="Variance Report" disabled={!auditMData.auditID} />
                            <Tab label="Audit History" disabled={!auditMData.auditID} />
                        </Tabs>
                    </Grid2>

                    {tabValue === 0 && (
                        <>
                            <Grid2 size={12} sx={{ marginTop: 3 }}>
                                <Typography sx={{ marginLeft: -1, color: 'grey', fontSize: 18, fontWeight: 'bolder' }}>Master Data</Typography>
                            </Grid2>

                            <Grid2 size={1.75}>
                                <DatePickerSelf name="entDate" value={auditMData.entDate} onChange={onChange} sx={{ width: '100%' }} disStatus={auditMData.auditID !== ''} />
                            </Grid2>

                            <Grid2 size={1}>
                                <TextFields label="Audit ID" name="auditID" value={auditMData.auditID} onChange={onChange} disStatus={true} />
                            </Grid2>

                            <Grid2 size={2}>
                                <AutoComplete label='Select Department' listData={departments || []} onChange={onChange} value={departments?.find((d) => d.deptID === auditMData.departmentID)} disabledValue={false} fieldName='departmentID' />
                            </Grid2>

                            <Grid2 size={2}>
                                <TextFields label="Branch ID" name="auditBranch" value={auditMData.auditBranch} onChange={onChange} disStatus={false} />
                            </Grid2>

                            <Grid2 size={3}>
                                <TextFields label="Opening Stock Value" name="openingStockValue" value={auditMData.openingStockValue} onChange={onChange} disStatus={false} />
                            </Grid2>

                            <Grid2 size={2.25}>
                                <TextFields label="Remarks" name="remarks" value={auditMData.remarks} onChange={onChange} disStatus={false} multiline={true} rows={2} />
                            </Grid2>

                            <Grid2 size={1.5}>
                                <ButtonNormal onClick={onMasterSave} text={'Save Master'} />
                            </Grid2>
                        </>
                    )}

                    {tabValue === 1 && auditMData.auditID !== '' && (
                        <>
                            <Grid2 size={12} sx={{ marginTop: 3 }}>
                                <Typography sx={{ marginLeft: -1, color: 'grey', fontSize: 18, fontWeight: 'bolder' }}>Add Audit Items</Typography>
                            </Grid2>

                            <Grid2 size={2.5}>
                                {isLoading ? <Loading /> : <AutoComplete label='Select Item' listData={items && items} onChange={onChange} value={items?.find((c) => c.itemCode === auditDData.itemCode)} disabledValue={false} />}
                            </Grid2>

                            <Grid2 size={1.5}>
                                <TextFields label="Current Stock" name="currentSystemStock" value={auditDData.currentSystemStock} onChange={onChange} disStatus={true} />
                            </Grid2>

                            <Grid2 size={1.5}>
                                <TextFields label="Audited Qty" name="quantity" value={auditDData.quantity} onChange={onChange} disStatus={false} />
                            </Grid2>

                            <Grid2 size={1.5}>
                                <ButtonNormal onClick={onDetailSave} text={'ADD ITEM'} />
                            </Grid2>

                            <Grid2 size={12}>
                                <Box sx={{ display: 'flex', gap: 2, marginBottom: 2 }}>
                                    <Button startIcon={<DownloadIcon />} onClick={exportToCSV} variant="outlined">Export CSV</Button>
                                </Box>
                            </Grid2>

                            <Grid2 size={12}>
                                {isLoading ? <Loading /> : <StickyHeadTable tableColumns={tableColumns} tableData={masterData?.data && masterData.data.length > 0 ? masterData.data : []} onEditClick={onEditClick} onDeleteClick={onDeleteClick} perPage={50} />}
                            </Grid2>
                        </>
                    )}

                    {tabValue === 2 && auditMData.auditID !== '' && (
                        <>
                            <Grid2 size={12} sx={{ marginTop: 3 }}>
                                <Typography sx={{ marginLeft: -1, color: 'grey', fontSize: 18, fontWeight: 'bolder' }}>Variance Report</Typography>
                            </Grid2>

                            <Grid2 size={12}>
                                {varianceReport?.data && varianceReport.data.length > 0 ? (
                                    <Paper sx={{ p: 2 }}>
                                        {varianceReport.data.map((item, idx) => (
                                            <Box key={idx} sx={{ p: 1.5, mb: 1, border: '1px solid #e0e0e0', borderRadius: 1, backgroundColor: item.variance > 0 ? '#fff3cd' : item.variance < 0 ? '#f8d7da' : '#fff' }}>
                                                <Grid2 container spacing={1}>
                                                    <Grid2 size={2}><strong>{item.itemDesc}</strong></Grid2>
                                                    <Grid2 size={2}>Opening: {item.openingStock}</Grid2>
                                                    <Grid2 size={2}>System: {item.systemStock}</Grid2>
                                                    <Grid2 size={2}>Audited: {item.auditedQuantity}</Grid2>
                                                    <Grid2 size={2}>Variance: <Chip label={item.variance} color={item.variance > 0 ? 'warning' : item.variance < 0 ? 'error' : 'default'} size="small" /></Grid2>
                                                    <Grid2 size={2}>Price Var: {item.priceVariance}</Grid2>
                                                </Grid2>
                                            </Box>
                                        ))}
                                    </Paper>
                                ) : (
                                    <Alert severity="info">No variance data available</Alert>
                                )}
                            </Grid2>
                        </>
                    )}

                    {tabValue === 3 && auditMData.auditID !== '' && (
                        <>
                            <Grid2 size={12} sx={{ marginTop: 3 }}>
                                <Typography sx={{ marginLeft: -1, color: 'grey', fontSize: 18, fontWeight: 'bolder' }}>Audit History</Typography>
                            </Grid2>

                            <Grid2 size={12}>
                                {auditHistory?.data && auditHistory.data.length > 0 ? (
                                    <Paper sx={{ p: 2 }}>
                                        {auditHistory.data.map((history, idx) => (
                                            <Box key={idx} sx={{ p: 1.5, mb: 1, border: '1px solid #e0e0e0', borderRadius: 1 }}>
                                                <Grid2 container spacing={1}>
                                                    <Grid2 size={2}><Chip label={history.actionType} size="small" /></Grid2>
                                                    <Grid2 size={4}>{history.description}</Grid2>
                                                    <Grid2 size={3}>By: {history.performedBy}</Grid2>
                                                    <Grid2 size={3}>{dayjs(history.performedAt).format('DD-MM-YYYY HH:mm')}</Grid2>
                                                </Grid2>
                                            </Box>
                                        ))}
                                    </Paper>
                                ) : (
                                    <Alert severity="info">No history available</Alert>
                                )}
                            </Grid2>
                        </>
                    )}

                    {auditMData.auditID && tabValue < 2 && (
                        <Grid2 size={12} sx={{ display: 'flex', gap: 2, marginTop: 3 }}>
                            {(!auditMData.approvalStatus || (auditMData.approvalStatus !== 'Approved' && auditMData.approvalStatus !== 'Rejected')) && (
                                <>
                                    <Button variant="contained" color="success" onClick={() => { setApprovalType('approve'); setShowApprovalDialog(true) }}>Approve Audit</Button>
                                    <Button variant="contained" color="error" onClick={() => { setApprovalType('reject'); setShowApprovalDialog(true) }}>Reject Audit</Button>
                                </>
                            )}
                            {auditMData.approvalStatus === 'Approved' && !auditMData.appliedToStock && (
                                <Button
                                    variant="contained"
                                    color="warning"
                                    onClick={() => {
                                        if (window.confirm('Do you want to apply this audit to stock? This action cannot be undone.')) {
                                            dispatch(applyAuditToStock({
                                                auditID: auditMData.auditID,
                                                appliedBy: currentUser?.userID
                                            })).then(res => {
                                                if (res.payload && res.payload.status) {
                                                    setAuditMData(prev => ({ ...prev, appliedToStock: 1 }))
                                                    alert('Audit has been applied to stock successfully!')
                                                } else {
                                                    alert('Error: ' + (res.payload || 'Apply failed'))
                                                }
                                            })
                                        }
                                    }}
                                >
                                    Apply to Stock
                                </Button>
                            )}
                            {auditMData.approvalStatus === 'Approved' && auditMData.appliedToStock === 1 && (
                                <Button variant="outlined" color="success" disabled>✓ Applied to Stock</Button>
                            )}
                        </Grid2>
                    )}
                </Grid2>

                <Dialog open={showEditDialog} onClose={() => setShowEditDialog(false)} maxWidth="sm" fullWidth>
                    <DialogTitle>Edit Audit Item</DialogTitle>
                    <DialogContent sx={{ pt: 2 }}>
                        <Grid2 container spacing={2}>
                            <Grid2 size={12}>
                                <TextFields label="Opening Stock" name="openingStock" value={auditDData.openingStock} onChange={onChange} disStatus={false} />
                            </Grid2>
                            <Grid2 size={12}>
                                <TextFields label="System Stock" name="currentSystemStock" value={auditDData.currentSystemStock} onChange={onChange} disStatus={true} />
                            </Grid2>
                            <Grid2 size={12}>
                                <TextFields label="Audited Quantity" name="quantity" value={auditDData.quantity} onChange={onChange} disStatus={false} />
                            </Grid2>
                        </Grid2>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setShowEditDialog(false)}>Cancel</Button>
                        <Button onClick={onEditSave} variant="contained">Save</Button>
                    </DialogActions>
                </Dialog>

                <Dialog open={showApprovalDialog} onClose={() => setShowApprovalDialog(false)} maxWidth="sm" fullWidth>
                    <DialogTitle>{approvalType === 'approve' ? 'Approve Audit' : 'Reject Audit'}</DialogTitle>
                    <DialogContent sx={{ pt: 2 }}>
                        <TextFields
                            label={approvalType === 'approve' ? 'Approval Comments' : 'Rejection Reason'}
                            name="comment"
                            value={approvalComment}
                            onChange={(data) => setApprovalComment(data.comment || '')}
                            disStatus={false}
                            multiline={true}
                            rows={4}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setShowApprovalDialog(false)}>Cancel</Button>
                        <Button onClick={approvalType === 'approve' ? handleApprove : handleReject} variant="contained" color={approvalType === 'approve' ? 'success' : 'error'}>{approvalType === 'approve' ? 'Approve' : 'Reject'}</Button>
                    </DialogActions>
                </Dialog>
            </Container>
        </>
    )
}
